import { Observable } from 'rxjs'
import { push } from 'react-router-redux'
import { apiUrl } from '../config/settings'
import { authTypes, generalTypes, reportTypes } from '../actions'
import { Headers, Auth } from '../helpers'

export const getPlayersReportEpic = (action$) => {
  return action$.ofType(reportTypes.PLAYERS)
    .switchMap(action => {
      return Observable
        .ajax(
          {
            url: `${apiUrl}/reports/participants/${action.city}`,
            method: 'GET',
            headers: Headers.getWithAuth()
          }
        )
        .map(res => ({ type: reportTypes.PLAYERS_RES, payload: res.response }))
        .catch(err => {
          if (err.status === 401) {
            return Observable
              .create(obs => {
                Auth.deauthenticateUser()
                obs.next({ type: authTypes.FAIL })
                obs.next(push('/login'))
                obs.complete()
              })
          }
        })
    })
}

export const playersReportResEpic = (action$) => {
  return action$.ofType(reportTypes.PLAYERS_RES)
    .switchMap(action => {
      return Observable
        .create(obs => {
          const { success } = action.payload
          if (success) {
            const { url } = action.payload
            obs.next({ type: reportTypes.SAVE_URL, payload: { url, key: 'players' } })
          } else {
            obs.next({ type: generalTypes.DISPLAY_ALERT, text: action.payload.err })
          }
          obs.complete()
        })
        .catch(err => console.log(err))
    })
}



// WEBPACK FOOTER //
// ./src/epics/reports.js